import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-deposit-return-statement-'
export default {
  path: '/report-center/accounts-deposit-return-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {cache: true, title: '退押退订报表'},
      component: () => import('@/pages/report-center/accounts-deposit-return-statement/index')
    },
  ]
}
